const testimonials = [
  {
    name: "Dr. Patricia W.",
    role: "FGCU Professor, Estero",
    highlight: "Conference in Barcelona — 9 days notice",
    story:
      "I was scheduled to present a paper at an international education conference in Barcelona. Nine days before my flight from RSW, I discovered my passport had expired three months earlier. I had been so focused on the presentation that I never checked. Fast Passport Center processed my renewal in four days. I made my flight, delivered my paper, and even had time for tapas on Las Ramblas. I have recommended them to three colleagues since.",
    rating: 5,
    tag: "Academic Travel",
  },
  {
    name: "Robert &amp; Linda M.",
    role: "Retirees from Grand Rapids, Estero",
    highlight: "Rhine River cruise — passport expired mid-planning",
    story:
      "We had been planning our Rhine River cruise for eighteen months. Linda checked her passport two weeks before departure and it had expired in January while we were down here in Estero. The cruise line said we could not board without six months validity. We called Fast Passport Center in a panic. They walked us through the renewal process, and Linda had her new passport in five days. We made the cruise, and it was the trip of a lifetime. We tell everyone in our retirement community about them.",
    rating: 5,
    tag: "River Cruise",
  },
  {
    name: "James K.",
    role: "Pelican Landing Resident, Estero",
    highlight: "Bimini fishing tournament — 3 days to departure",
    story:
      "I entered a Bimini fishing tournament with my boat crew. Three days before we were set to leave from Fort Myers Beach, I realized my passport had expired six months ago. Tournament fees were non-refundable, and the weather window was perfect. Fast Passport Center got my renewal processed and shipped to my door in 72 hours. We made the Saturday departure, and I actually placed third in the tournament. I still cannot believe how fast they moved.",
    rating: 5,
    tag: "Emergency",
  },
];

export default function EsteroTestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Estero Client Stories
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Estero Travelers Say About Us
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 md:p-8 border border-gray-100 shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>

              <div className="inline-block bg-[#F6C344]/10 text-[#1A365D] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full mb-4">
                {t.tag}
              </div>

              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.story}&rdquo;
              </p>

              <div className="border-t border-gray-100 pt-4">
                <div className="font-semibold text-[#1A365D] text-sm">{t.name}</div>
                <div className="text-gray-500 text-xs">{t.role}</div>
              </div>

              <div className="mt-3 bg-[#1A365D]/5 rounded-md px-3 py-2">
                <p className="text-[#1A365D] text-xs font-semibold">{t.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}